module.exports = __webpack_public_path__ + "static/04-c9d9af503bba965303a60040bccae683.jpg";